import { useSyncExternalStore } from "react";

/**
 * How much of the viewport's right edge the Photos page's record side panel
 * currently covers, in px (0 when no panel is open).
 *
 * The page's floating Upload button is rendered by the bottom nav, outside the
 * records view, and is pinned to the viewport's right edge — exactly where the
 * panel's action bar sits. A module-level store lets the view publish the
 * panel width and the nav read it without a provider spanning both.
 * See [[records-view.spec]] US-006.
 */
let inset = 0;
const listeners = new Set<() => void>();

export function setRecordPanelInset(next: number): void {
  const rounded = Math.max(0, Math.round(next));
  if (rounded === inset) return;
  inset = rounded;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const getSnapshot = () => inset;

export function useRecordPanelInset(): number {
  return useSyncExternalStore(subscribe, getSnapshot, () => 0);
}
